module.exports = __webpack_public_path__ + "5cd6d324b4dcfaeeab40f5271c4d3f80.jpg";